'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// css


var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

require('react-select/dist/react-select.css');

require('react-datepicker/dist/react-datepicker.css');

require('./styles/modify-react-datepicker.css');

var _Router = require('./components/Router');

var _Router2 = _interopRequireDefault(_Router);

var _addValidators = require('./utils/validation/addValidators');

var _addValidators2 = _interopRequireDefault(_addValidators);

var _provideCoactContext = require('./components/enhancers/provideCoactContext');

var _provideCoactContext2 = _interopRequireDefault(_provideCoactContext);

var _provideAuth = require('./components/enhancers/provideAuth');

var _provideAuth2 = _interopRequireDefault(_provideAuth);

var _provideRedux = require('./components/enhancers/provideRedux');

var _provideRedux2 = _interopRequireDefault(_provideRedux);

var _connectServer = require('./components/enhancers/connectServer');

var _connectServer2 = _interopRequireDefault(_connectServer);

var _Menu = require('./components/Menu');

var _Menu2 = _interopRequireDefault(_Menu);

var _Password = require('./components/Password');

var _Password2 = _interopRequireDefault(_Password);

var _DocList = require('./components/DocList');

var _DocList2 = _interopRequireDefault(_DocList);

var _DocEditor = require('./components/DocEditor');

var _DocEditor2 = _interopRequireDefault(_DocEditor);

var _NotFoundPage = require('./components/NotFoundPage');

var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);

var _GroupEditor = require('./components/GroupEditor');

var _GroupEditor2 = _interopRequireDefault(_GroupEditor);

var _StreamData = require('./components/StreamData');

var _StreamData2 = _interopRequireDefault(_StreamData);

var _withCoactModels = require('./models/withCoactModels');

var _withCoactModels2 = _interopRequireDefault(_withCoactModels);

var _withCoactViews = require('./views/withCoactViews');

var _withCoactViews2 = _interopRequireDefault(_withCoactViews);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// TO IMPROVE schema 增加系統欄位，放到獨立模組
function addSysField(schema) {
  return _extends({}, schema, {
    contents: _extends({}, schema.contents, {
      _id: { type: 'ObjectId', autogeneratable: true },
      '@@createdAt': { type: 'Date' },
      '@@updatedAt': { type: 'Date' }
    })
  });
}

function extendSchema(objs) {
  var result = {};
  Object.keys(objs).forEach(function (key) {
    var schema = objs[key].schema;

    if (schema) {
      result[key] = _extends({}, objs[key], {
        schema: (0, _addValidators2.default)(addSysField(schema))
      });
    } else {
      result[key] = objs[key];
    }
  });
  return result;
}

function wrapConnectServer(routes) {
  return routes.map(function (route) {
    if (route.path && (route.path.startsWith('/search') || route.path.startsWith('/edit'))) {
      return _extends({}, route, { component: (0, _connectServer2.default)(route.component) });
    }
    return route;
  });
}

var launchCoact = function launchCoact(config) {
  var models = config.models,
      views = config.views,
      ui = config.ui,
      routes = config.routes;


  var routesInMain = [{ component: _Menu2.default, path: '/', exact: true }].concat(_toConsumableArray(routes), [{ component: _Password2.default, path: '/password' }, { component: _GroupEditor2.default, path: '/edit/groups/:id' }, { component: _DocList2.default, path: '/search/:view' }, { component: _DocEditor2.default, path: '/edit/:view/:id' }, { component: _StreamData2.default, path: '/stream/data' }, { component: _NotFoundPage2.default }]);

  var App = (0, _composeWithScope2.default)(_provideCoactContext2.default, _provideRedux2.default, _provideAuth2.default, (0, _withProps2.default)({
    routesInMain: wrapConnectServer(routesInMain),
    // TODO flatten config, expose models, views, ui?
    config: {
      models: extendSchema((0, _withCoactModels2.default)(models)),
      views: extendSchema((0, _withCoactViews2.default)(views)),
      ui: ui
    }
  }), (0, _exposeProps2.default)(['auth', 'routesInMain', 'config']))(_Router2.default);

  return App;
};

exports.default = launchCoact;


//////////////////
// WEBPACK FOOTER
// ./~/coact/coact.js
// module id = 469
// module chunks = 0